import { useContext, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LocationAddress } from '@components';
import { GlobalContext } from '@contexts';
import {
  Edit2Icon,
  ExternalLinkIcon,
  MonitorIcon,
  MoreHorizontalIcon,
} from '@svgs';

const WebsiteCard = ({ locationsByID, website }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-website-item">
      <div>
        <Link to={`/dashboard/sites/${website.id}`}>
          <span className="img-contain">
            <img
              src={website.screenshot_thumbnail}
              alt={website.display_url}
              width="640"
              height="400"
            />
          </span>
        </Link>
      </div>
      <div className="sb-website-info sb-flex">
        <div>
          <p>{website.display_url}</p>
          {website.adjusted_base_directory == '/' &&
            website.location_ids.length === 0 &&
            locationsByID && (
              <p className="sb-subtitle">
                Primary website ({Object.keys(locationsByID).length} location
                {Object.keys(locationsByID).length != 1 ? 's' : ''})
              </p>
            )}
          {website.location_ids.length === 1 &&
            locationsByID &&
            locationsByID[website.location_ids[0]] && (
              <>
                {locationsByID[website.location_ids[0]].location_name && (
                  <p className="sb-subtitle">
                    {locationsByID[website.location_ids[0]].location_name}
                  </p>
                )}
                <p className="sb-subtext">
                  <LocationAddress
                    location={locationsByID[website.location_ids[0]]}
                  />
                </p>
              </>
            )}
          {website.location_ids.length > 1 && (
            <p>{website.location_ids.length} locations</p>
          )}
          {website.location_ids.length === 1 && !locationsByID && <p>...</p>}
        </div>
        <div className="sb-website-options sb-options">
          <button
            className="sb-website-options-menu-trigger sb-options-trigger"
            onClick={() => setShowDropdownMenu(!showDropdownMenu)}
          >
            <MoreHorizontalIcon />
          </button>
          <div
            ref={dropdownMenu}
            className={
              'sb-website-options-menu sb-options-menu ' +
              (showDropdownMenu ? 'sb-show' : 'sb-hide')
            }
          >
            <div className="sb-options-menu-content">
              <Link
                to={`/dashboard/sites/${website.id}/custom_fields`}
                className="sb-website-options-edit sb-options-item"
              >
                <Edit2Icon />
                {t('Manage content')}
              </Link>
              <a
                href={
                  website.published
                    ? website.formatted_url
                    : website.preview_url
                }
                target="_blank"
                className="sb-website-options-view-website sb-options-item"
              >
                <MonitorIcon />
                {t('View website')}
              </a>
              {globals.visible.websiteViewPreview && (
                <a
                  href={website.preview_url}
                  target="_blank"
                  className="sb-website-options-view-preview sb-options-item"
                >
                  <ExternalLinkIcon />
                  {t('View preview')}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteCard;
